// @flow
export const SWITCH_PAGE: 'SWITCH_PAGE' = 'SWITCH_PAGE';



// WEBPACK FOOTER //
// ./src/constants/NavigationActionTypes.js